import React, {  Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import 'moment-timezone';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

/* Actions */
import {
    ajaxRequestCompleted,
	updateBookedOrder
} from '../../redux/actions';

class changeRequestedDeliveryDateOverlayDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDialog: false,
            minDate: moment().hours(0).minutes(0).seconds(0).milliseconds(0),
            date: null,
            isRequestFinished: false,
            errorMessage: '',
            successMessage: '',
            formData: {
                param: {
			  		requestedDeliveryDate: null
				},
				error: {
					requestedDeliveryDateError: ""
				}
            }
        };
        this.handleChangeRDD = this.handleChangeRDD.bind(this);
        this.timeoutId = null
    }

    componentWillUnmount() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId)
        }
    }

    handleChangeRDD(date) {
	  	const self = this;
	  	self.setState({
		  	date: date ? date.hours(0).minutes(0).seconds(0).milliseconds(0) : date,
			invalidDateSelectionErrorMessage: '',
			formData: {
				...self.state.formData,
				param: {
					...self.state.formData.param,
			  		requestedDeliveryDate: date && date.format('MM/DD/YYYY')
				},
				error: {
					...self.state.formData.error,
					requestedDeliveryDateError: ""
				}
		  	},
            errorMessage: ''
	  	});
	}

    closeDialog(event) {
        event && event.preventDefault();
        this.props.handleDialog(this.props.flag, false);
    }

    handleUpdate(event) {
        event.preventDefault();
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
        const self = this;
        const {
            formData: {
                param,
                error
            }
        } = self.state;
        if (param.requestedDeliveryDate) {
			if (self.props.fromWhichPage === "manageOrder" && param.originalRequestedDeliveryDate === param.requestedDeliveryDate) {
				self.setState({
					errorMessage: 'Please select a new date to update.'
				});
			} else {
				if (self.props.fromWhichPage === "manageOrder") {
					self.setState({
		                isRequestFinished: false,
                        isUpdateInProgress: false,
		                errorMessage: '',
		                successMessage: '',
		            },() => {
		                const payload = self.props.orderDetail;
		                payload.updatedRequestedDeliveryDate = param.requestedDeliveryDate;
                        const currentRequestedDeliveryDate = moment.tz(param.originalRequestedDeliveryDate, 'MM/DD/YYYY', 'America/New_York');
                        const newRequestedDeliveryDate = moment.tz(param.requestedDeliveryDate, 'MM/DD/YYYY', 'America/New_York');
                        if (newRequestedDeliveryDate.isBefore(currentRequestedDeliveryDate)) {
                            payload.items && payload.items.forEach(item => {
                                item.scheduleArrivalDate = newRequestedDeliveryDate.format();
                                item.requestedDeliveryDate = newRequestedDeliveryDate.format();
                                item.overrideATPDateCode = "N";
                            })
                        }

                        this.timeoutId = setTimeout(() => {
                            this.props.ajaxRequestCompleted();
                            this.timeoutId = null;
                            self.setState({
                                isUpdateInProgress: true,
                                isRequestFinished: true,
                                successMessage: 'The update has been submitted but is taking time to complete. Please check back in 30 minutes to confirm the order update.'
                            }, () => {
                                self.props.callBackAfterRDDUpdate(this.props.orderDetail && this.props.orderDetail.requestedDeliveryDate);
                            });
                        }, 60000);

		                self.props.updateBookedOrder(payload, 'requestType=updateRequestedDeliveryDate&fullyReserved='+payload.fullyReservedOrder, response => {
                            if (this.timeoutId) {
                                clearTimeout(this.timeoutId);
                                this.timeoutId = null;

                                if(response.status) {
                                    if(response.responseObject) {
                                        self.setState({
                                            isRequestFinished: true,
                                            successMessage: 'Requested Delivery Date has been updated successfully.'
                                        }, () => {
                                            self.props.callBackAfterRDDUpdate(param.requestedDeliveryDate);
                                        });
                                    } else {
                                        self.setState({
                                            errorMessage: 'Failed to update requested delivey date.'
                                        });
                                    }
                                } else {
                                    self.setState({
                                        errorMessage: 'Error occured while updating requested delivery date'
                                    });
                                }
                            }
		        		});
		            });
				} else if (self.props.fromWhichPage === "bookedOrder") {
					self.props.callBackAfterRDDUpdate(param.requestedDeliveryDate);
				}
			}
        } else {
            error.requestedDeliveryDateError = 'error';
            self.setState({
                errorMessage: 'Please select a date',
                formData: {
                    ...self.state.formData,
                    error
                }
            });
        }
    }

    componentWillMount() {
        const { shippingMethod, orderDetail, deliveryCalendar } = this.props;
        // It should default to the month of the current (header) RDD with the current header RDD selected.
        // We should only offer dates that are LATER (in the future) than the current RDD.
        // We should offer only M-F if that is easy to do.
        const originalRequestedDeliveryDate = moment(this.props.pickTheDateFromString(orderDetail.requestedDeliveryDate, 'MM/DD/YYYY'), 'MM/DD/YYYY');
        const today = moment().hours(0).minutes(0).seconds(0).milliseconds(0);

        const groupArrivalDate = this.props.groupArrivalDate && moment(this.props.pickTheDateFromString(this.props.groupArrivalDate, 'MM/DD/YYYY'), 'MM/DD/YYYY');
        let minDate;
        if (groupArrivalDate) {
            minDate = groupArrivalDate.add(1, 'days');
            minDate = minDate.isBefore(today) ? today.clone() : minDate;
            if (minDate.isSameOrAfter(originalRequestedDeliveryDate)) {
                minDate = null;
            }
        }

        if (['SDS Delivery', 'SDS Will Call'].includes(shippingMethod)) {
            // set last available date as maxDate
            const lastAvailableCalendarDate = deliveryCalendar && deliveryCalendar.findLast(calendarDate => calendarDate.available && calendarDate.date);
            const maxDate = lastAvailableCalendarDate ? moment(lastAvailableCalendarDate.date, 'MM/DD/YYYY') : undefined;
            minDate = minDate || (originalRequestedDeliveryDate.isBefore(today) ? today : originalRequestedDeliveryDate);
            // check if minDate is available on calendar, if not available, set the next available date as minDate
            const minCalendarDate = deliveryCalendar && deliveryCalendar.find(calendarDate => calendarDate.available && calendarDate.date && minDate.isSameOrBefore(moment(calendarDate.date, 'MM/DD/YYYY')));
            minDate = minCalendarDate && moment(minCalendarDate.date, 'MM/DD/YYYY');

            const date = originalRequestedDeliveryDate.isSameOrAfter(minDate) ? originalRequestedDeliveryDate : null;
            this.setState({
                date,
                minDate,
                maxDate,
                formData: {
                    ...this.state.formData,
                    param: {
                        ...this.state.formData.param,
                        requestedDeliveryDate: date && date.format('MM/DD/YYYY'),
                        originalRequestedDeliveryDate: originalRequestedDeliveryDate && originalRequestedDeliveryDate.format('MM/DD/YYYY'),
                    }
                }
            })
        } else {
            let date = originalRequestedDeliveryDate;
            if (!minDate) {
                // set requested delivery date as per create order logic
                if(date.isBefore(today)) {
                    date = today.add(1, 'day');
                    if(shippingMethod === 'ADC LTL') {
                        date = moment().hours(0).minutes(0).seconds(0).milliseconds(0).add(2, 'days');
                    } else if(shippingMethod === 'ADC Will Call') {
                        date = moment().hours(0).minutes(0).seconds(0).milliseconds(0);
                    }
                }
            }
            minDate = minDate || date || null;
            // If the date is M-F keep it, else unset it
            date = (date && ![0, 6].includes(date.day())) ? date : null;
            this.setState({
                date,
                minDate,
                formData: {
                    ...this.state.formData,
                    param: {
                        ...this.state.formData.param,
                        requestedDeliveryDate: date && date.format('MM/DD/YYYY'),
                        originalRequestedDeliveryDate: originalRequestedDeliveryDate && originalRequestedDeliveryDate.format('MM/DD/YYYY'),
                    }
                }
            });
        }
    }

	componentDidMount() {
		this.setState({
            showDialog: true
        });
	}

    render() {
        const self = this;
        const {
            minDate,
            maxDate,
            date,
            formData: {
                error: {
                    requestedDeliveryDateError
                }
            },
            isRequestFinished,
            isUpdateInProgress,
            errorMessage,
            successMessage,
        } = self.state;
        const showSDSCalendar = this.props.shippingMethod === 'SDS Delivery' || this.props.shippingMethod === 'SDS Will Call';
        const deliveryCalendar = this.props.deliveryCalendar || [];

        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="changeRequestedDeliveryDateOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <h2 className="title">{this.props.fromWhichPage === 'manageOrder' ? 'Change' : 'Select'} Requested Delivery Date</h2>
                    {isRequestFinished
                        ? <div>
                            <p className={isUpdateInProgress ? 'orange' : 'green'}>{successMessage}</p>
                            <div className="yesButtonContainer">
                            <a className="yesButton blueButton fontSize-10" onClick={this.closeDialog.bind(this)} href="">Ok</a>
                            </div>
                        </div>
                        : <div>
                            {errorMessage ? <p className="red">{errorMessage}</p> : null}
                            <div className={`${requestedDeliveryDateError} requestDeliverDateDiv`}>
                                <DatePicker
                                    minDate={minDate}
                                    maxDate={maxDate}
                                    id="requestedDeliveryDate"
                                    placeholderText="Click to select a requested delivery date"
                                    selected={date}
                                    filterDate={showSDSCalendar ? date => deliveryCalendar.some(calendarDate => calendarDate.available && calendarDate.date === date.format('MM/DD/YYYY')) : self.props.isWeekday}
                                    onChange={this.handleChangeRDD}
                                    inline
                                    readOnly
                                />
                            </div>
                            <div className="noButtonContainer">
        						<a className="noButton blueButton fontSize-10" onClick={this.closeDialog.bind(this)} href="">Cancel</a>
                            </div>
                            <div className="yesButtonContainer">
                                <a className="yesButton blueButton fontSize-10" onClick={this.handleUpdate.bind(this)} href="">Update</a>
                            </div>
                        </div>
                    }

                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	updateBookedOrder: (payload, params, response) => dispatch(updateBookedOrder(payload, params, response)),
    ajaxRequestCompleted: () => dispatch(ajaxRequestCompleted())
});

changeRequestedDeliveryDateOverlayDialog = connect(mapStateToProps, mapDispatchToProps)(changeRequestedDeliveryDateOverlayDialog);
export default changeRequestedDeliveryDateOverlayDialog;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/changeRequestedDeliveryDateOverlayDialog.js